import { Component } from '@angular/core'
import { AuthService } from '@app/core/service/auth.service'
import { UploadType } from '@app/shared/components/upload-modal/models/upload-modal-config'
import { UploadModalService } from '../services/upload-modal.service'

@Component({
  selector: 'upload-modal-header',
  templateUrl: './upload-modal-header.component.html',
  styleUrls: ['./upload-modal-header.component.scss'],
})
export class UploadModalHeaderComponent {
  get data() {
    return this.uploadModalService.modalConfig
  }

  constructor(
    private authService: AuthService,
    protected uploadModalService: UploadModalService
  ) {}

  onGenerateTemplate() {
    ;(this.data.type === UploadType.COMPONENT ||
      (this.data.type === UploadType.FIXED_FEE_COMPONENT && this.data.includeRoleAndHour) ||
      this.data.type === UploadType.TASK) &&
    this.authService.loggedInUser.hasPrivilege('RATECARD__VIEW')
      ? (this.uploadModalService.showGenerateTemplate = true)
      : this.uploadModalService.getTemplateExampleUrl()
  }

  getInstructionUrl() {
    const staticUrl = 'https://scopebetter.zendesk.com/hc/en-gb/articles/'
    switch (this.data.type) {
      case UploadType.CLIENTS:
        return staticUrl + '360007333137-How-do-I-upload-clients'
      case UploadType.LOCATION:
        return staticUrl + '360007393938-How-do-I-upload-locations'
      case UploadType.CONTACT:
        return staticUrl + '360007394338-How-do-I-upload-contacts'
      case UploadType.BRAND:
        return staticUrl + '360007394858-How-do-I-upload-brands'
      case UploadType.RATECARD:
        return staticUrl + '360007390718-How-do-I-upload-a-Ratecard'
      case UploadType.DELIVERABLE:
        return staticUrl + '360007964497-How-do-I-upload-deliverables'
      case UploadType.FIXED_FEE_DELIVERABLE:
        return staticUrl + '28869840126749-How-do-I-upload-Fixed-Fee-Deliverables'
      case UploadType.TASK:
        return staticUrl + '23026786302109-How-do-I-upload-a-Task'
      case UploadType.COMPONENT:
        return staticUrl + '360007099138-How-do-I-upload-components'
      case UploadType.FIXED_FEE_COMPONENT:
        return staticUrl + '28889681134749-How-do-I-upload-Fixed-Fee-Components'
      case UploadType.DELIVERABLE_WITH_COMPONENTS:
        return staticUrl + '31049557974813-Copying-Deliverables-to-New-Disciplines'
      default:
        return ''
    }
  }

  protected readonly UploadType = UploadType
}
